<template>
  <div>
    <div class="header-area">
      <div class="banner" v-if="stateInfo.showBanner" @click="gotoAliYun">
        <i class="iconfont icon-delete banner-delete" @click.stop="closeBanner"></i>
      </div>
      <div class="clever-main-menu">
        <div class="classy-nav-container breakpoint-off">
          <nav class="classy-navbar justify-content-between" id="cleverNav">

            <!-- // {{ sysConfig.sys_web_name }} -->
            <a class="nav-brand hidden-sm-only" href="/cn/main?lang=en"><img style="width:241px; height: 50px;"
                src="/static/img/logo_20240419094118.png" /></a>
            <div class="classy-menu">
              <div class="classynav">
                <div class="search-area hidden-sm-only">
                  <el-input type="search" prefix-icon="el-icon-search" v-model="query" name="search" id="search"
                    :placeholder="$t('search')" @keyup.enter.native="search()" />
                </div>
                <el-menu :default-active="activeIndex" mode="horizontal" text-color="rgba(0, 0, 0, 0.45)"
                  active-text-color="#232323" :unique-opened=true @select="handleSelect">
                  <el-menu-item index="/index" @click="open('/cn/main?lang=' + lang)">{{ $t('home') }}</el-menu-item>
                  <el-submenu v-if="login && userInfo.identifier!=='sigenergy'" index="/user-info">
                    <template slot="title">
                      <img v-if="userInfo.avatar && userInfo.avatar !== ''" :src="userInfo.avatar"
                        style="width: 30px;height: 30px;border-radius: 50%;margin-right:6px;" />
                      <i v-else class="iconfont icon-user"
                        style="font-size: 28px; margin-right:6px; color: #5a5a5a;"></i>
                      {{ userInfo.identifier }}
                    </template>
                    <!-- <el-menu-item index="account" @click="openCert(userInfo.id)">{{ $t('header.personal')
                      }}</el-menu-item> -->
                    <!-- <el-menu-item index="password" @click="open('/password')">{{$t('header.changePwd')}} -->
                   </el-menu-item>
                  <el-menu-item index="logOut" @click="logOut">{{ $t('header.logout') }}</el-menu-item>
                  </el-submenu>
                </el-menu>
                <div class="register-login-area" v-if="!login || userInfo.identifier =='sigenergy'">
                  <!-- <a class="btn" target="_blank" @click="open('/register')">{{ $t('register') }}</a> -->
                  <!-- <a class="btn" target="_blank" @click="open('/login')">{{ $t('login2') }}</a> -->
                  <a class="btn" target="_blank" @click="loginOpen">{{ $t('login') }}</a>
                </div>
                <div class="register-login-area" v-if="login && userInfo.identifier!=='sigenergy'">
                  <a class="btn" target="_blank" @click="openCert(userInfo.id)">{{ $t('header.personal')}}</a>
                </div>
                <div>
                  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
                    <div>
                      {{
                        language === 'zh' ? '中文' : language === 'en' ? 'English' : language === 'de' ? 'Deutsch' :
                          language === 'es' ?
                            'Español' : language === 'oo'
                      }}
                    </div>
                    <el-dropdown-menu slot="dropdown" style="padding-left: 12px; padding-right: 12px;">
                      <el-dropdown-item :disabled="language === 'zh'" command="zh">
                        中文
                      </el-dropdown-item>
                      <el-dropdown-item :disabled="language === 'en'" command="en">
                        English
                      </el-dropdown-item>
                      <el-dropdown-item :disabled="language === 'de'" command="de">
                        Deutsch
                      </el-dropdown-item>
                      <el-dropdown-item :disabled="language === 'es'" command="es">
                        Español
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <o-main ref="mainRef" style="height: 100%;"></o-main>
  </div>
</template>

<script>
import store from '@/store';
import OMain from './common/main';
import { mapGetters, mapState } from 'vuex';
import { messageWarn } from '@/utils/util';
import { setStore, getStore } from '@/utils/store';
import { SEARCH_HISTORY } from '@/utils/storeMap';
import { switchLanguage } from "@/api/sigen/paginationLang";
import { getProblemById, getLoginSSO } from "@/api/sigen/myCertificate";
// import { getUserInfo } from '@/api/admin/user';

export default {
  components: {
    OMain
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      stateInfo: state => state.stateInfo.stateInfo
    }),
    ...mapGetters([
      'sysConfig'
    ])
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang, 2);
    this.checkLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    this.init();
    this.getLoginMessage();
  },
  watch: {
    $route() {
      this.checkLogin()
      this.pushUrl = window.location.href;
      console.log('cilckSetLanguage Route watch this.pushUrl  :', this.pushUrl);
    }
  },
  data() {
    return {
      language: "en",
      activeIndex: '/index',
      login: false,
      userData: null,
      input: '',
      query: '',
      lang: 'en',
      pushUrl: '',
      bool: false,
      pdfPath: '',
      smain: '',
      params: '',
      loginUrl: ''
    }
  },
  methods: {
    getLoginMessage() {
      console.log('++++++++++++++++++++++++++++  :  this.loginUrl :  ', this.loginUrl);
      getLoginSSO().then(res => {
        this.smain = res.data.result.smain;
        this.params = res.data.result.params;
        this.loginUrl = this.smain + this.params;
      }).catch(error => {
        console.error(error)
      })
    },
    getMyCertificate(userId) {
      getProblemById(userId).then(res => {
        this.bool = res.data.result.bool;
        this.pdfPath = res.data.result.pdfPath;
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>  getMyCertificate pdfPath: {} ', res.data.result.pdfPath);
        if (this.pdfPath === null) {
          messageWarn(this, this.$t('exam.course.doReqexam'))
        } else { window.open(res.data.result.pdfPath, '_blank'); }
      }).catch(error => {
        console.error(error)
      })
    },
    switchLanguage(lang) {
      switchLanguage(lang)
    },
    init() {
      if (this.pushUrl === '') {
        this.pushUrl = window.location.href;
        console.log('cilckSetLanguage Route created this.pushUrl  :', this.pushUrl);
      }
      var str = this.pushUrl.substring(this.pushUrl.lastIndexOf('=') + 1, this.pushUrl.length);
      var purl = this.pushUrl.substring(0, this.pushUrl.lastIndexOf('=') + 1);

      if (str === undefined || str === 'undefined') {
        this.pushUrl = purl + 'en';
      }
      if (this.language === undefined || this.language === 'undefined') {
        this.language = 'en';
      }
      if ((this.pushUrl.lastIndexOf('?') < 0) && (this.pushUrl.lastIndexOf('lang=')) < 0) {
        this.pushUrl = this.pushUrl + '?lang=' + this.lang;
        console.log("-->pushurl2:" + this.pushUrl)
        this.$router.push(this.pushUrl)
      }
    },
    openCert(userId) {
      console.log('++++++++++++++++++++++++++ encryptedValue userId :  ', userId);
      this.getMyCertificate(userId);
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang
      if (lang === undefined || lang === 'undefined') {
        lang = 'en';
        // this.$router.push('/main?lang=en')
      }
      return lang;
    },
    mounted() {
      this.$i18n.locale = 'en';
    },
    closeBanner() {
      store.dispatch('SetStateInfo', { showBanner: false })
    },
    gotoAliYun() {
      window.open('https://www.aliyun.com/minisite/goods?userCode=gg8hcnqt')
    },
    handleSetLanguage(lang, flag) {
      // this.$i18n.locale = lang
      this.language = lang
      this.lang = lang;
      console.log('cilckSetLanguage Route this.language:', this.language);
      console.log('cilckSetLanguage Route flag:', flag);
      // 视频播放页面判断
      var video = "/video-details?";
      this.judgment(video, 0);
      // 登录判断
      var login = "/cn/login";
      this.judgment(login, 0);
      // 注册判断
      var register = "/cn/register";
      this.judgment(register, 0);
      // 账户中心
      var account = "/cn/account";
      this.judgment(account, 0);
      // 修改密码
      var password = "/cn/password";
      this.judgment(password, 0);

      // // 问题明细
      // var problem = "/problem-details";
      // this.judgment(problem, 0);
      // // 质保条款明细
      // var warranty = "/warranty-details";
      // this.judgment(warranty, 0);
      // // 技术通知明细
      // var notice = "cn/notice-details?";
      // this.judgment(notice, 1);
      var course = "cn/course-details?";
      this.judgment(course, 2);
      var exam = 'cn/exam-details';
      this.judgment(exam, 2);
      var item = '/exam-items?';
      console.log('++++++++++++++++++++++++++ exam-items item :  ', item);
      this.judgment(item, 3);

      if (flag !== 2) {
        this.cilckSetLanguage(lang);
      }
    },

    judgment(path, type) {
      // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  this.pushUrl :  ', this.pushUrl);
      var normalizedStr = this.pushUrl.toLowerCase().trim();
      var normalized = path.toLowerCase();
      var pattern = new RegExp("\\b" + normalized.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&") + "\\b", "ig");
      var result = pattern.test(normalizedStr);
      if (result) {
        if (type === 0) {
          // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>judgment judgment this.lang :  ', this.lang);
          this.$router.push('/cn/main?lang=' + this.lang);
        } else if (type === 1) {
          window.open('/cn/main?lang=' + this.lang);
        } else if (type === 2) {
          window.open('/search?lang=' + this.lang);
        } else if (type === 3) {
          console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>judgment judgment 3333 this.lang :  ', this.lang);
          this.$router.push('/cn/main?lang=' + this.lang)
        }
      }
    },

    judgmentPalyer(href) {
      var path = '/video-details';
      var normalizedStr = this.pushUrl.toLowerCase().trim();
      var normalized = path.toLowerCase();
      var pattern = new RegExp("\\b" + normalized.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&") + "\\b", "ig");
      var result = pattern.test(normalizedStr);
      if (result) {
      } else {
        window.open(href, '_self');
      }
    },
    cilckSetLanguage(lang) {
      console.log('cilckSetLanguage Route parameter lang:', lang);
      var url = window.location.href;
      // 截取之前的内容
      var index = url.lastIndexOf('?')
      var href = url.substring(0, index + 1)
      console.log("request  address  start :  ", href);
      href = href + "lang=" + lang;
      console.log("request  address end url :  ", href);
      this.judgmentPalyer(href);
      // window.open(href, '_self');
      console.log("request  address :  ", window.location.href);
    },
    openAdmin() {
      window.open(window.location.origin + '/admin')
    },
    handleSubmitExam() {
      this.$refs.mainRef.handleSubmitExam()
    },
    loginOpen() {
      window.open(this.loginUrl + this.lang);
    },
    open(path) {
      if (path.startsWith('http')) {
        window.open(path)
        return
      }

      if (path !== this.$route.fullPath) {
        if (this.$route.fullPath === '/start') {
          this.$confirm('是否要结束当前考试？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // TODO 提交当前考试
            this.$emit('handleSubmitExam')
            this.$router.push({
              path: path,
              query: {}
            })
          }).catch(() => {
          })
        } else {
          this.$router.push({
            path: path,
            query: {}
          })
        }
      }
    },
    handleSelect(item) {
    },
    handleRegister() {
      // 先退出
      // this.logOut()
      this.$router.push('/register')
    },
    handleLogin() {
      this.$router.push('/login')
    },
    logOut() {
      this.$store.dispatch('LogOut').then(() => {
        this.login = false
        this.$router.push('/cn/main?lang=' + this.lang)
      }).catch(() => {
        this.login = false
        this.$router.push('/cn/main?lang=' + this.lang)
      })
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true
      }
    },
    search() {
      if (this.query && this.query !== '') {
        this.$router.push({ name: 'search', query: { query: this.query, lang: this.lang } })
        const tmp = getStore({
          name: SEARCH_HISTORY
        })
        let res = []
        if (tmp && tmp.length > 0) {
          res = tmp
          let index = tmp.findIndex(item => item === this.query)
          if (index === -1) {
            res.push(this.query)
          }
        } else {
          res.push(this.query)
        }
        setStore({
          name: SEARCH_HISTORY,
          content: res
        })
      }
    },
    todo() {
      messageWarn(this, '功能正在开发中！')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/css/style.scss";

html,
body {
  height: 100%;
}

.international {
  padding: 20px;
}

.banner {
  height: 60px;
  background-image: url(https://img.alicdn.com/imgextra/i3/O1CN01Tbj8qb1w835uueixH_!!6000000006262-2-tps-3840-120.png);
  background-position: center center;
  background-size: auto 100%;
  position: relative;
  cursor: pointer;

  .banner-delete {
    font-size: 20px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue